<template>
  <div class="container-fluid">
    <loading :active.sync="isLoading" :can-cancel="false" color="#007BFF" :is-full-page="true">
    </loading>
    <CustomModal :is-modal="!canPlaySounds" :close-outh="false" :show-close-btn="false" :delete-header="false" :delete-footer="false" width="md">
      <template #header-center>
        <h5 class="modal-title">Permiso de notificaciones</h5>
      </template>
      <div class="text-center">
        <p>Para una mejor experiencia, necesitamos tu permiso para reproducir notificaciones de sonido cuando lleguen nuevos pedidos.</p>
      </div>
      <template #actions>
        <button type="button" class="btn btn-secondary" @click="enableSoundNotifications">Activar notificaciones</button>
      </template>
    </CustomModal>
    <div class="d-flex align-items-center  m-1 mt-5">
      <h1 class="board-title">Estatus de pedidos</h1>
      <button v-if="!canPlaySounds" @click="enableSoundNotifications" class="btn btn-primary ml-3 d-flex align-items-center">Activar alerta de pedidos<i class="ni ni-bell-off ml-3" style="font-size: 1rem"></i></button>
      <i v-if="canPlaySounds" class="ni ni-bell-55 ml-4 text-primary" style="font-size: 1.1rem"></i>
    </div>
    <div class="row pt-4">
      <div class="col-12 col-md-3">
        <div class="card card-column-border">
          <div class="card-header">
            <div class="d-flex justify-content-between">
              <div class="">
                <h2 class="card-title-column">{{ listOrderPending.title }}</h2>
              </div>
              <div class="ms-auto">
                <span class="card-badge-count badge-circle badge-lg">{{ listOrderPending.cards.length }}</span>
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <draggable
              :data-column="listOrderPending.identifier"
              style="min-height: 662px"
              v-model="listOrderPending.cards"
              group="orders"
              @start="drag=true"
              @end="onDragEnd"
              :move="handleMove">

              <div class="container card-item card-item-color-pending py-2 my-3 px-3" 
                   :class="{ 'pulse-animation': isOrderActive(element) }"
                   @click="showOrderStatus(element)" 
                   :id="`${element.id}`"
                   :data-order="JSON.stringify(element)" 
                   v-for="element in listOrderPending.cards" 
                   :key="element.id">
                <div class="row justify-content-between px-2">
                    <h1 class="card-title-number-order">ID {{ element.id }}</h1>
                    <div class="d-flex align-items-center">
                      <div v-if="element.source_in_app" class="mr-2">
                        <span class="badge badge-pill text-uppercase" :class="getSourceClass(element.source_in_app)" :style="getSourceStyle(element.source_in_app)">
                          {{ getSourceLabel(element.source_in_app) }}
                        </span>
                      </div>
                      <img :src="getDeliveryImage(element)" alt="" />
                      <img v-if="element.is_special === 1" class="justify-end ml-2" src="/img/clientSpecial.svg" alt=""/>
                    </div>
                </div>
                <p class="card-title-client">Cliente: <span> {{ element.customer }}</span></p>
                <p class="card-title-start-preparation">Hora estimada inicio de preparación:</p>
                <span class="card-badge-time card-badge-start-preparation-pending badge-primary py-1 px-1">
                 <i class="ni ni-watch-time"></i> <span> {{ element.time_prep_estimated }} - {{
                    element.delivery_date
                  }}</span>
                </span>
              </div>
            </draggable>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-3">
        <div class="card">
          <div class="card-header">
            <div class="d-flex justify-content-between">
              <div class="">
                <h2 class="card-title-column">{{ listOrderInPreparation.title }}</h2>
              </div>
              <div class="ms-auto">
                <span class="card-badge-count badge-circle badge-lg">{{ listOrderInPreparation.cards.length }}</span>
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <draggable :data-column="listOrderInPreparation.identifier" style="min-height: 662px" v-model="listOrderInPreparation.cards"
                       group="orders" @start="drag=true" @end="onDragEnd" :move="handleMove">
              <div class="card-item card-item-color-in-preparation py-3 my-3 px-4" @click="showOrderStatus(element)"
                   :data-order="JSON.stringify(element)" v-for="element in listOrderInPreparation.cards"
                   :key="element.id">
                <div class="row justify-content-between px-2">
                    <h1 class="card-title-number-order">ID {{ element.id }}</h1>
                    <div class="d-flex align-items-center">
                      <div v-if="element.source_in_app" class="mr-2">
                        <span class="badge badge-pill text-uppercase" :class="getSourceClass(element.source_in_app)" :style="getSourceStyle(element.source_in_app)">
                          {{ getSourceLabel(element.source_in_app) }}
                        </span>
                      </div>
                      <img :src="getDeliveryImage(element)" alt="" />
                      <img v-if="element.is_special === 1" class="justify-end ml-2" src="/img/clientSpecial.svg" alt=""/>
                    </div>
                </div>
                <p class="card-title-client">Cliente: <span> {{ element.customer }}</span></p>
                <p class="card-title-start-preparation">Hora estimada pedido listo:</p>
                <span class="card-badge-time card-badge-start-preparation-in-preparation badge-primary py-1 px-1">
                 <i class="ni ni-watch-time"></i><span> {{ element.hour_estimated_ready }}-{{
                    element.delivery_date
                  }}</span>
                </span>
              </div>
            </draggable>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-3">
        <div class="card">
          <div class="card-header">
            <div class="d-flex justify-content-between">
              <div class="">
                <h2 class="card-title-column">{{ listOrderReady.title }}</h2>
              </div>
              <div class="ms-auto">
                <span class="card-badge-count badge-circle badge-lg">{{ listOrderReady.cards.length }}</span>
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <draggable :data-column="listOrderReady.identifier" style="min-height: 662px" v-model="listOrderReady.cards" group="orders"
                       @start="drag=true" @end="onDragEnd" :move="handleMove">
              <div class="card-item card-item-color-ready py-3 my-3 px-4" @click="showOrderStatus(element)"
                   v-for="element in listOrderReady.cards" :key="element.id">
                <div class="row justify-content-between px-2">
                    <h1 class="card-title-number-order">ID {{ element.id }}</h1>
                    <div class="d-flex align-items-center">
                      <div v-if="element.source_in_app" class="mr-2">
                        <span class="badge badge-pill text-uppercase" :class="getSourceClass(element.source_in_app)" :style="getSourceStyle(element.source_in_app)">
                          {{ getSourceLabel(element.source_in_app) }}
                        </span>
                      </div>
                      <img :src="getDeliveryImage(element)" alt="" />
                      <img v-if="element.is_special === 1" class="justify-end ml-2" src="/img/clientSpecial.svg" alt=""/>
                    </div>
                </div>
                <p class="card-title-client">Cliente: <span> {{ element.customer }}</span></p>
                <p class="card-title-start-preparation">Hora pedido listo:</p>
                <span class="card-badge-time card-badge-start-preparation-ready badge-primary py-1 px-1">
                 <i class="ni ni-watch-time"></i> <span> {{ element.date_ready }}</span>
                </span>
              </div>
            </draggable>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-3">
        <div class="card">
          <div class="card-header">
            <div class="d-flex justify-content-between">
              <div class="">
                <h2 class="card-title-column">{{ listOrderInRoute.title }}</h2>
              </div>
              <div class="ms-auto">
                <span class="card-badge-count badge-circle badge-lg">{{ listOrderInRoute.cards.length }}</span>
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <draggable :data-column="listOrderInRoute.identifier" style="min-height: 662px" v-model="listOrderInRoute.cards" group="orders"
                       @start="drag=true" @end="onDragEnd" :move="handleMove">
              <div class="card-item card-item-color-in-route py-3 my-3 px-4" @click="showOrderStatus(element)"
                   v-for="element in listOrderInRoute.cards" :key="element.id">
                <div class="row justify-content-between px-2">
                    <h1 class="card-title-number-order">ID {{ element.id }}</h1>
                    <div class="d-flex align-items-center">
                      <div v-if="element.source_in_app" class="mr-2">
                        <span class="badge badge-pill text-uppercase" :class="getSourceClass(element.source_in_app)" :style="getSourceStyle(element.source_in_app)">
                          {{ getSourceLabel(element.source_in_app) }}
                        </span>
                      </div>
                      <img :src="getDeliveryImage(element)" alt="" />
                      <img v-if="element.is_special === 1" class="justify-end ml-2" src="/img/clientSpecial.svg" alt=""/>
                    </div>
                </div>
                <p class="card-title-client">Cliente: <span> {{ element.customer }}</span></p>
                <p class="card-title-start-preparation">Hora pedido en ruta:</p>
                <span class="card-badge-time card-badge-start-preparation-in-route  badge-primary py-1 px-1">
                 <i class="ni ni-watch-time"></i> <span> {{ element.date_in_route }}</span>
                </span>
              </div>
            </draggable>
          </div>
        </div>
      </div>
    </div>
    <CustomModal :is-modal="showDialog" @closeModal="checkIfStatusChanged" :closeOuth="true" width="xlg">
      <FoodcourtOrderBoard ref="foodcourtOrderBoad" :order="selectedOrder" @onLoading="onLoading"
                           @onOrderChange="onOrderChange"></FoodcourtOrderBoard>
    </CustomModal>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import {format} from "date-fns";
import CustomModal from "@/components/CustomModal.vue";
import FoodcourtOrderBoard from "./FoodcourtOrderBoard.vue";
import BackofficeApi from "@/gateways/backoffice-api";
import Loading from 'vue-loading-overlay';
import OrderStatusBoard from "../../utils/OrderStatusBoard";
import {sortByTime} from "@/utils/sort-by";

export default {
  components: {
    CustomModal,
    draggable,
    FoodcourtOrderBoard,
    Loading
  },
  name: "FoodcourtOrderStatusBoard",
  data() {
    return {
      canPlaySounds: false,
      soundInterval: null,
      timeCheckInterval: null,
      listOrderPending: {
        title: 'Realizado / Agendado',
        identifier: OrderStatusBoard.PENDING.identifier,
        cards: []
      },
      listOrderInPreparation: {
        title: 'En preparación',
        identifier: OrderStatusBoard.IN_PREPARATION.identifier,
        cards: []
      },
      listOrderReady: {
        title: 'Listo',
        identifier: OrderStatusBoard.READY.identifier,
        cards: []
      },
      listOrderInRoute: {
        title: 'En ruta',
        identifier: OrderStatusBoard.IN_ROUTE.identifier,
        cards: []
      },
      isLoading: false,
      selectedOrder: null,
      showDialog: false,
      evenAction: null,
      element: {
        type: Object,
        required: true
      }
    }
  },
  computed: {
    host() {
      return process.env.VUE_APP_API_BACKOFFICE_URL.replace("/api/v1/", "");
    },
    filteredPendingOrders() {
      const currentTime = new Date();
      const currentHours = currentTime.getHours().toString().padStart(2, '0');
      const currentMinutes = currentTime.getMinutes().toString().padStart(2, '0');
      const currentSeconds = currentTime.getSeconds().toString().padStart(2, '0');
      const currentTimeString = `${currentHours}:${currentMinutes}:${currentSeconds}`;

      return this.listOrderPending.cards.filter(order => {
        return order.time_prep_estimated <= currentTimeString;
      });
    }
  },
  beforeMount() {
    this.test_audio();
  },
  async mounted() {
    if (this.$store.getters.getKitchenId) {
      await this.getFoodcourtOrderBoard();
    }
    this.startTimeCheckInterval();
    window.Echo.channel("private-newOrderFoodcourt." + this.$store.getters.getKitchenId)
        .listen(".new-order-foodcourt", e => {
          console.log('si funcionaa', e)
          new Audio('sounds/new-order-foodcourt.wav').play();
          this.listOrderPending.cards.push(e.data)
          this.listOrderPending.cards = sortByTime(this.listOrderPending.cards, 'time_prep_estimated');
        })
    window.Echo.channel("private-changeOrderStatusFoodCourtBoard." + this.$store.getters.getKitchenId)
        .listen(".change-order-status-foodcourt-board", e => {
          console.log('change order status', e)
          this.handleOrderStatusEvent(e)
        })

    window.addEventListener('mousedown', this.onUserInteraction);
  },
  beforeDestroy() {
    if (this.soundInterval) {
      clearInterval(this.soundInterval);
    }
    if (this.timeCheckInterval) {
      clearInterval(this.timeCheckInterval);
    }
    window.removeEventListener('mousedown', this.onUserInteraction)
    window.Echo.leaveChannel("private-newOrderFoodcourt." + this.$store.getters.getKitchenId)
    window.Echo.leaveChannel("private-changeOrderStatusFoodCourtBoard." + this.$store.getters.getKitchenId)
  },
  watch: {
    'filteredPendingOrders': {
      handler(newCards) {
        this.handleSoundNotification(newCards);
      },
      deep: true
    }
  },
  methods: {
    enableSoundNotifications() {
      this.canPlaySounds = true;
      this.handleSoundNotification(this.filteredPendingOrders);
    },
    handleSoundNotification(cards) {
      if (this.canPlaySounds) {
        if (cards.length > 0) {
          if (!this.soundInterval) {
            this.soundInterval = setInterval(() => {
              new Audio('sounds/new-order-foodcourt.wav').play();
            }, 3000); // Play sound every 5 seconds
          }
        } else {
          if (this.soundInterval) {
            clearInterval(this.soundInterval);
            this.soundInterval = null;
          }
        }
      }
    },
    getDeliveryImage(element) {
      if (element.order_delivery_type == 'delivery' && element.franchise_delivery_type == 'take_away') {
        return '/img/foodcourt/delivery.svg';
      } else if (element.order_delivery_type != 'delivery' && element.franchise_delivery_type == 'eat_here') {
        return '/img/foodcourt/eatHere.svg';
      } else if (element.order_delivery_type != 'delivery' && element.franchise_delivery_type == 'take_away') {
        return '/img/take_await.svg';
      } else {
        return ''; // O una imagen por defecto si no se cumple ninguna condición
      }
    },
    getSourceLabel(source) {
      const s = source.toLowerCase();
      if (s === 'restaurante') {
        return 'Restaurante';
      } else if (s === 'menu_diario') {
        return 'Menú Diario';
      }
      return source.replace('_', ' ');
    },
    getSourceClass(source) {
      const s = source.toLowerCase();
      if (s === 'restaurante') {
        return 'badge-info';
      } else if (s === 'menu_diario') {
        return 'badge-source-menu-diario';
      }
      return 'badge-source-menu-diario';
    },
    getSourceStyle(source) {
      const s = source.toLowerCase();
      if (s === 'menu_diario') {
        return 'background-color: #E1FEF1; color: #1AAE6F; font-size: 0.7rem; padding: 0.4em 0.8em;';
      } else if (s === 'restaurante') {
        return 'font-size: 0.7rem; padding: 0.4em 0.8em;';
      }
      return 'font-size: 0.7rem; padding: 0.4em 0.8em;';
    },
    async test_audio() {
      try {
        await new Audio('sounds/test-audio.wav').play();
        this.canPlaySounds = true;
      } catch (error) {
        this.canPlaySounds = false;
      }
    },
    onUserInteraction() {
      setTimeout(() => {
        this.canPlaySounds = true;
        }, 150);
    },
    async getFoodcourtOrderBoard() {
      this.isLoading = true;
      const currentDate = format(new Date(), 'YYYY-MM-DD');
      const path = this.host + '/api/v3/foodcourt/orders/board'
      let response = await BackofficeApi.get(
          path,
          {
            params: {
              dark_kitchen_id: this.$store.getters.getKitchenId,
              currentDate
            }
          }
      );
      this.listOrderPending = response.data.detail.boardColumns.find(column => column.identifier === OrderStatusBoard.PENDING.identifier);
      this.listOrderInPreparation = response.data.detail.boardColumns.find(column => column.identifier === OrderStatusBoard.IN_PREPARATION.identifier);
      this.listOrderReady = response.data.detail.boardColumns.find(column => column.identifier === OrderStatusBoard.READY.identifier);
      this.listOrderInRoute = response.data.detail.boardColumns.find(column => column.identifier === OrderStatusBoard.IN_ROUTE.identifier);
      this.isLoading = false;
    },
    checkIfStatusChanged() {
      if (OrderStatusBoard.PENDING.status.includes(this.selectedOrder.status_tracking_id)) {
        const index = this.listOrderInPreparation.cards.findIndex(order => order.order_id === this.selectedOrder.order_id);
        if (index !== -1) {
          this.listOrderInPreparation.cards.splice(index, 1);
          this.listOrderPending.cards.push(this.selectedOrder);
          this.listOrderPending.cards = sortByTime(this.listOrderPending.cards, 'time_prep_estimated');
        }
      }

      if (this.selectedOrder.status_tracking_id === OrderStatusBoard.CANCELED.status) {
        const index = this.listOrderInPreparation.cards.findIndex(order => order.order_id === this.selectedOrder.order_id);
        if (index !== -1) {
          this.listOrderInPreparation.cards.splice(index, 1);
          this.listOrderInPreparation.cards = sortByTime(this.listOrderInPreparation.cards, 'hour_estimated_ready');
        }
      }

      if (this.selectedOrder.status_tracking_id === OrderStatusBoard.IN_PREPARATION.status) {
        const index = this.listOrderInPreparation.cards.findIndex(order => order.order_id === this.selectedOrder.order_id);
        if (index !== -1) {
          this.listOrderInPreparation.cards[index] = this.selectedOrder;
          this.listOrderInPreparation.cards = sortByTime(this.listOrderInPreparation.cards, 'hour_estimated_ready');
        }
      }

      if (this.selectedOrder.status_tracking_id === OrderStatusBoard.READY.status && this.evenAction === 'click') {
        const index = this.listOrderInPreparation.cards.findIndex(order => order.order_id === this.selectedOrder.order_id);
        if (index !== -1) {
          this.listOrderInPreparation.cards.splice(index, 1);
          this.listOrderReady.cards.push(this.selectedOrder);
          this.listOrderReady.cards = sortByTime(this.listOrderReady.cards, 'date_ready');
        }
      }

      this.selectedOrder = null;
      this.showDialog = false;
      this.evenAction = null;
    },
    onOrderChange(order, eventAction) {
      this.selectedOrder = order;
      this.evenAction = eventAction;
      this.checkIfStatusChanged();
    },
    showOrderStatus(order) {
      this.selectedOrder = order;
      this.showDialog = true;
    },
    handleOrderStatusToReady(order) {
      this.$refs.foodcourtOrderBoad.updateOrderStatus(order, OrderStatusBoard.READY.status, 'drag')
    },
    onLoading(isLoading) {
      this.isLoading = isLoading;
    },
    onDragEnd(event) {
      // Aquí puedes manejar la lógica cuando se suelta un elemento
      //console.log('onDragEnd: Elemento soltado:', event);
    },
    handleMove(event) {
      const draggedItem = event.dragged;
      const toList = event.to;
      const fromList = event.from;

      const fromData = fromList.dataset
      const toData = toList.dataset

      if (fromData.column === OrderStatusBoard.PENDING.identifier && toData.column === OrderStatusBoard.IN_PREPARATION.identifier) {
        this.selectedOrder = JSON.parse(draggedItem.dataset.order)
        this.showDialog = true;
        return true;
      }

      if (fromData.column === OrderStatusBoard.PENDING.identifier &&
          [OrderStatusBoard.READY.identifier, OrderStatusBoard.IN_ROUTE.identifier].includes(toData.column)) {
        return false;
      }

      if (fromData.column === OrderStatusBoard.IN_PREPARATION.identifier && [OrderStatusBoard.PENDING.identifier, OrderStatusBoard.IN_ROUTE.identifier].includes(toData.column)) {
        return false;
      }

      if (fromData.column === OrderStatusBoard.IN_PREPARATION.identifier && toData.column === OrderStatusBoard.READY.identifier) {
        const order = JSON.parse(draggedItem.dataset.order)
        const searchOrder = this.listOrderInPreparation.cards.find(orderItem => orderItem.order_id === order.order_id)
        if (searchOrder) {
          this.handleOrderStatusToReady(searchOrder)
          return true
        }
        return false
      }

      if (fromData.column === OrderStatusBoard.READY.identifier && [OrderStatusBoard.IN_PREPARATION.identifier, OrderStatusBoard.PENDING.identifier, OrderStatusBoard.IN_ROUTE.identifier].includes(toData.column)) {
        return false
      }

      if (fromData.column === toData.column) {
        return draggedItem.parentNode !== toList;
      }

    },
    handleOrderStatusEvent(e) {
      if (e.data.status === OrderStatusBoard.IN_PREPARATION.status) {
        const index = this.listOrderPending.cards.findIndex(order => order.id === e.data.order_id)
        if (index === -1) return
        const order = this.listOrderPending.cards[index]
        order.status_name = OrderStatusBoard.IN_PREPARATION.name
        order.status_tracking_id = OrderStatusBoard.IN_PREPARATION.status
        order.hour_estimated_ready = e.data.hour_estimated_ready
        this.listOrderPending.cards.splice(index, 1)
        this.listOrderInPreparation.cards.push(order)
        this.listOrderInPreparation.cards = sortByTime(this.listOrderInPreparation.cards, 'hour_estimated_ready');
      }

      if (e.data.status === OrderStatusBoard.READY.status) {
        const index = this.listOrderInPreparation.cards.findIndex(order => order.id === e.data.order_id)
        if (index === -1) return
        const order = this.listOrderInPreparation.cards[index]
        order.status_name = OrderStatusBoard.READY.name
        order.status_tracking_id = OrderStatusBoard.READY.status
        order.date_ready = e.data.date_ready
        this.listOrderInPreparation.cards.splice(index, 1)
        this.listOrderReady.cards.push(order)
        this.listOrderReady.cards = sortByTime(this.listOrderReady.cards, 'date_ready');
      }

      if (e.data.status === OrderStatusBoard.IN_ROUTE.status) {
        const index = this.listOrderReady.cards.findIndex(order => order.id === e.data.order_id)
        if (index === -1) return
        const order = this.listOrderReady.cards[index]
        order.status_name = OrderStatusBoard.IN_ROUTE.name
        order.status_tracking_id = OrderStatusBoard.IN_ROUTE.status
        order.date_in_route = e.data.date_in_route
        this.listOrderReady.cards.splice(index, 1)
        this.listOrderInRoute.cards.push(order)
        this.listOrderInRoute.cards = sortByTime(this.listOrderInRoute.cards, 'date_in_route');
      }

      if (e.data.status === 6) {
        const index = this.listOrderPending.cards.findIndex(order => order.id === e.data.order_id)
        if (index === -1) return
        this.listOrderPending.cards.splice(index, 1)
        this.listOrderPending.cards = sortByTime(this.listOrderPending.cards, 'time_prep_estimated');
      }
    },
    isOrderActive(order) {
      const currentTime = new Date();
      const currentHours = currentTime.getHours().toString().padStart(2, '0');
      const currentMinutes = currentTime.getMinutes().toString().padStart(2, '0');
      const currentSeconds = currentTime.getSeconds().toString().padStart(2, '0');
      const currentTimeString = `${currentHours}:${currentMinutes}:${currentSeconds}`;
      
      return order.time_prep_estimated <= currentTimeString;
    },
    startTimeCheckInterval() {
      this.timeCheckInterval = setInterval(() => {
        this.updatePendingOrdersStatus();
      }, 1000); // Check every second
    },
    updatePendingOrdersStatus() {
      // Force Vue to recognize the change by creating a new array
      this.listOrderPending.cards = [...this.listOrderPending.cards];
    }
  },
  destroyed() {
    console.log('destroyed')
    window.Echo.leaveChannel("private-newOrderFoodcourt." + this.$store.getters.getKitchenId)
    window.Echo.leaveChannel("private-changeOrderStatusFoodCourtBoard." + this.$store.getters.getKitchenId)
  }
}
</script>

<style scoped>
.card-item-color-pending {
  border: #1171EF80 1px solid;
}

.card-item-color-in-preparation {
  border: #FB634080 1px solid;
}

.card-item-color-ready {
  border: #1AAE6F80 1px solid;
}

.card-item-color-in-route {
  border: #596CFF 1px solid;
}

.card-item {
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.card-badge-time {
  border-radius: 8px;
  color: #FFFFFF;
  @media (max-width: 1024px) {
    margin: 0 -10px;
    font-size: 12px !important;
  }
}

.card-badge-start-preparation-pending {
  background-color: #E7F0FD;
  color: #1171EF;
  font-weight: 600;
  font-size: 14px;
}

.card-badge-start-preparation-in-preparation {
  background-color: #FFEDE9;
  color: #FB6340;
  font-weight: 600;
  font-size: 14px;
}

.card-badge-start-preparation-ready {
  background-color: #E1FEF1;
  color: #1AAE6F;
  font-weight: 600;
  font-size: 14px;
}

.card-badge-start-preparation-in-route {
  background-color: #E7E9FF;
  color: #596CFF;
  font-weight: 600;
  font-size: 14px;
}

.board-title {
  font-size: 30px;
}

.card-title-client {
  display: flex;
  align-items: flex-start;
  margin: 0 -10px;
  @media (max-width: 1500px) {
      flex-direction: column;
  }
  font-weight: 600;
  font-size: 14px;
  color: #32325D;
}

.card-title-client span {
  font-weight: 400;
}

.card-title-start-preparation {
  font-weight: 600;
  font-size: 14px;
  @media (min-width: 768px) {
    margin: 10px -10px;
  }
  color: #32325D;
}

.card-title-number-order {
  font-size: 24px;
  @media (min-width: 768px) {
    font-size: 18px;
  }
}

.card-title-column {
}

.card-badge-count {
  background-color: #F8F9FA;
  border: #32325D 1px solid;
  font-size: 16px;
}

.card-column-border {
}

.card-body {
  min-height: 662px;
}

.modal-title {
  color: #32325D;
  font-weight: 600;
  margin: 0;
}

.text-center p {
  color: #525F7F;
  margin: 0;
  padding: 1rem;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 0, 0, 0.4);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(255, 0, 0, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(255, 0, 0, 0);
  }
}

.pulse-animation {
  animation: pulse 2s infinite;
}

.badge-source-menu-diario {
  background-color: #E1FEF1 !important;
  color: #1AAE6F !important;
}
</style>
